import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import AuthModal from "@/components/AuthModal";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import ResetPassword from "@/pages/ResetPassword";
import HeavyParts from "@/pages/HeavyParts";
import { Toaster } from "sonner";
import LeadRequests from "@/pages/LeadRequests";
import PageAnalytics from "@/components/PageAnalytics";

function ScrollToAnchor() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
      else window.scrollTo(0, 0);
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash]);
  return null;
}

function AdminEntry() {
  const { user } = useAuth();
  if (user === null) return <main id="main-content" className="ep-shell ep-section">Vérification de votre accès…</main>;
  return user?.role === "admin" ? <Admin /> : <Navigate to="/admin/demandes" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <div className="App">
            <Header />
            <ScrollToAnchor />
            <Routes>
              <Route path="/" element={<HeavyParts />} />
              <Route path="/recherche" element={<Navigate to="/pl-tp" replace />} />
              <Route path="/produit/:id" element={<Navigate to="/#demande-pl-tp" replace />} />
              <Route path="/panier" element={<Navigate to="/#demande-pl-tp" replace />} />
              <Route path="/paiement/succes" element={<PaymentSuccess />} />
              <Route path="/compte" element={<Account />} />
              <Route path="/admin" element={<AdminEntry />} />
              <Route path="/admin/demandes" element={<LeadRequests />} />
              <Route path="/mentions-legales" element={<Legal />} />
              <Route path="/categorie/:slug" element={<Navigate to="/pl-tp" replace />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/pneus" element={<Navigate to="/pl-tp" replace />} />
              <Route path="/pl-tp" element={<HeavyParts />} />
              <Route path="/carrosserie" element={<Navigate to="/pl-tp" replace />} />
              <Route path="/fournisseurs" element={<Navigate to="/" replace />} />
              <Route path="*" element={<main id="main-content" className="ep-shell ep-section"><h1 className="text-3xl font-bold">Cette page n’existe plus.</h1><p className="mt-4">Notre équipe vous accompagne pour votre demande de pièce.</p><a className="ep-button mt-6" href="/#demande-pl-tp">Demander ma pièce</a></main>} />
            </Routes>
            <AuthModal />
            <Toaster position="top-right" richColors closeButton />
            <PageAnalytics />
          </div>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
